/** @format */

import template from './gb-add-notification-widget.html';

export const GbAddNotificationWidgetComponent = {
    template,
    require: {
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddNotificationWidgetComponent {
        constructor($gbNotificationProjectorWidget, $translate, $ccColors, $mdColors) {
            'ngInject';

            this.$gbNotificationProjectorWidget = $gbNotificationProjectorWidget;
            this.$translate = $translate;
            this.$ccColors = $ccColors;
            this.$mdColors = $mdColors;
        }

        addWidget() {
            let bgColor = this.$mdColors.getThemeColor('default-background');
            let secondaryBgColor = this.$mdColors.getThemeColor('default-primary');

            let widget = new this.$gbNotificationProjectorWidget({
                show_bid_notifications: true,
                show_custom_notifications: true,
                show_donation_notifications: true,
                show_purchase_notifications: true,
                x: 30,
                y: 15,
                x_unit: '%',
                y_unit: '%',
                width: 40,
                width_unit: '%',
                height: 70,
                height_unit: '%',
                opacity: 1,
                background_color: bgColor,
                color: this.$ccColors.getContrast(bgColor),
                notif_type: 'popout_a',
                notif_secondary_background_color: secondaryBgColor,
                notif_secondary_color: this.$ccColors.getContrast(secondaryBgColor),
                font_size: 20,
            });

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
